export default {
    state: {
        plugInfo: null,

        brtmap:{

            language:1,     //1中文 2英文

            ZONEIDS:{},     //号馆属于大类（区域概念）

            ready:false,    //地图准备状态

            $mapStep:{      //地图步骤
                type:'',
                poiID:'',
                openQQMapRoute:false,
            },

            guideView:true,     //首页引导


            $CAR_FIRST:true,        //车行优先
            $CAR_BASE_FIRST:true,   //车行优先默认值

            openVehicle:false,      //开启车行选择方式
            existVehicle:false,     //存在车行规划

            map:{},                 //弃用大数据监听

            lastRoute:'/map',       //上次路由

            speacilRoute:'',        //上上次路由

            $maker:'',              //地图图标集合

            $search:'',             //搜索实例

            parkNoInfo:'',              //分配的空车位数据

            $selecte:{              //选点操作
                point:'',           //选点

                startPoint:'',      //起点
                endPoint:'',        //终点
            },

            $locate:{               //定位相关
                init:true,          //初次定位
                islocate:true,      //是否定位
                point:'',           //定位点（弃用）
                test:false,         //测试

                allowFloor:true,    //允许切换楼层
            },

            $route:{
                route:'',
                isExit:'',             //逃生模式
                isExitPoint:'',        //逃生节点
                ignore:[],             //路径方式
                vehicle:false,         //车行方式
                vehicleRoute:0,        //0人行 1车行 (用的时候取反)

                enterType:'',           //进入方式

                selectType:{            //选点方式
                    type:'',
                    pointType:'',
                    point:''
                },

                keyPoints:[],

                // overView:null,         //全览控制
            },

            $NAVTO:{        //导航相关

                $NAVSIMULATE:'',       //模拟导航实例
                $ISSIMULATE:'',      //开启了模拟导航监听

                $NAVINDICATE:'',    //步行导航实例

                NAVType:'',         //导航类型，步行或模拟

                $mp3Audio:[],        //导航与语音

                // playAudio:null,     //播放语音

                lastPlayIndex:'',     //播放语音，索引
                playAudioINDEX:'',   //播放语音，索引

                timer:'',             //计时器

                angle:'',             //记角度

                NAV_EASETO:true,        //更动地图

                testPoint:'',         //实际导航测试点

                NAVInfo:{           //导航信息(顶部变化所需数据)

                    route:'',     //路段

                    total:'',     //总距离

                    passed:'',    //已通过距离

                    residue:'',   //当前段剩余距离

                    direction:'', //下一个节点方向

                    rssi:'',      //信号变化

                    directionTXT:'',  //方向提示

                    repeatDIR:false,    //持续转向

                    empty:'',           //清空
                },

            },

            $options:{

                use3D:false,
                voice:true,

                Footprint:false,        //历史足迹/收藏夹
                FootprintTabIndex:1,         //收藏夹

                GuideDrawer:false,      //功能栏

                PoiListDrawer:0,    //地图底部poi列表筛选
                PoiListData:'',         //筛选数据
                PoiListMaker:[],        //筛选图标

            },

            $active:{
                shopDatas:'',
                shopPoint:'',
                shopMakers:[],
                initEnter:'',           //特殊进入
                enterActiveDetail:0,    //进入活动详情
            },

            $findCar:{
                timer:'',
            },

            $filter:{       //筛选操作
                open:false,
                initEnter:'',
                enter:'',
            },

            $urlParam:{ //链接操作
                share:{
                    status:false,
                    poiId:'',
                    LABEL_X:'',
                    LABEL_Y:'',
                    FLOOR_ID:''
                },

                shopActive:{status:false,selete:''},

                NomapReady:'',//地图未准备操作

                filter:{
                    status:false,
                    name:'',
                    resetName:'',

                    location:[],    //需定位后操作
                    initShow:[],    //需初始显示操作
                },

                //寻车参数
                findCar:{
                    status:false,
                    enterType:'',
                    buildingId:'',
                    userId:'',
                    applyId:'',
                    carNo:''
                },

                findNullPark:{status:false},

                nearLift:{status:false,type:0},

                planRoute:{status:false,startPoi:'',endPoi:''}
            },
            cardActive:{},
            $nav:''                     //弃用

        },

        qqmap:{}
    },
    mutations: {},
    getter:{},
    actions: {},
}
